// extracted by mini-css-extract-plugin
export default {"overlay":"plain-modal_overlay__ohmTh","modal":"plain-modal_modal__US0Rt","empty":"plain-modal_empty__wI+gf","placeHolderShimmer":"plain-modal_placeHolderShimmer__qt6+x"};